import en from './en.json';
import es from './es.json';
import pt from './pt.json';
import fr from './fr.json';
import de from './de.json';
import ko from './ko.json';
import zh from './zh.json';

export const translations = {
  en,
  es,
  pt,
  fr,
  de,
  ko,
  zh
};

export default translations;
